module.exports = __webpack_public_path__ + "static/media/google-play-badge.38408b9a.png";